import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["button"]
  declare readonly buttonTarget: HTMLButtonElement

  toggle(): void {
    const shouldActivate = this.buttonTarget.getAttribute("aria-expanded") === "false"

    this.buttonTarget.setAttribute("aria-expanded", shouldActivate ? "true" : "false")

    if (shouldActivate) {
      window.scrollTo({ top: 0, behavior: "smooth" })
    }
  }

  hide(event: FocusEvent | MouseEvent): void {
    const targetToCheck = (event.relatedTarget ?? event.target) as Node

    if (!this.element.contains(targetToCheck)) {
      this.buttonTarget.setAttribute("aria-expanded", "false")
    }
  }
}
